import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

// Dynamically set <title> based on route + asso name (white-label)
export default function PageTitle() {
  const { pathname } = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    let title = 'AssoPerf — Plateforme SaaS pour associations';
    if (pathname.startsWith('/espace')) {
      // White-label: show asso name only, no AssoPerf
      title = user?.asso_nom ? `${user.asso_nom} — Espace membre` : 'Espace membre';
    } else if (pathname.startsWith('/dashboard')) {
      title = user?.asso_nom ? `${user.asso_nom} — Administration` : 'Administration';
    } else if (pathname.startsWith('/admin')) {
      title = 'AssoPerf — Super Admin';
    } else if (pathname === '/login') {
      title = 'Connexion — AssoPerf';
    } else if (pathname === '/register') {
      title = 'Créer mon association — AssoPerf';
    }
    document.title = title;
  }, [pathname, user]);

  return null;
}
